import { PointInfo } from "../../WalltoFittingInfo";
import { WallGrid } from "../WallGrid";

/**
 * 壁の交点に頂点がない場合、頂点を追加する
 * */
export class CrossWallAddPoint extends WallGrid {

    constructor(public pointList: PointInfo[]) {
        super(pointList);
    }

    public execute(): PointInfo[] {

        const isExist = (createWallList: THREE.Vector3[], p1: THREE.Vector3, p2: THREE.Vector3): boolean => {
            for (let i = 0; i < createWallList.length; i+=2) {
                const p3 = createWallList[i];
                const p4 = createWallList[i+1];
                if (p1.clone().sub(p3).length() < this.e && p2.clone().sub(p4).length() < this.e) return true;
            }
            return false;
        }

        let createWall: THREE.Vector3[] = [];
        for (let i = 0; i< this.pointList.length; i+=2) {
            const start = this.pointList[i].point;
            const end = this.pointList[i+1].point;
            if (this.pointList[i].isDelete == true || this.pointList[i+1].isDelete == true) continue;

            for (let j = 0; j < this.pointList.length; j++) {
                if (i == j || i + 1 == j) continue;
                if (this.pointList[j].isDelete == true) continue;
                
                const point = this.pointList[j].point;
                const dir1 = point.clone().sub(start);
                const dir2 = end.clone().sub(start);
                // 線分上にある            
                if (0 < (dir1.clone().dot(dir2) / dir2.length()) && (dir1.clone().dot(dir2) / dir2.length()) < dir2.length()) {                    
                    // e以内 高さ方向
                    const height = dir1.clone().cross(dir2).clone().divideScalar(dir2.length());
                    if (height.length() < this.e) {
                        // 頂点を作って壁を分割する
                        this.pointList[i].isDelete = true;
                        this.pointList[i+1].isDelete = true;
                        if (!isExist(createWall, this.pointList[i].point, point)) {
                            createWall.push(this.pointList[i].point);
                            createWall.push(point);
                        }
                        if (!isExist(createWall, point, this.pointList[i+1].point)) {
                            createWall.push(point);
                            createWall.push(this.pointList[i+1].point);
                        }
                    }
                }
            }
        }

        // 重複していたらカットして、ユニークにする
        createWall = this.unique(createWall);    
        if (createWall == null || createWall.length == 0) return this.pointList;
            
        createWall.forEach((p: THREE.Vector3) => {
            this.pointList.push({
                point: p.clone(),
                isDelete: false,
                isExist: true 
            });
        });

        return this.pointList;

    }

    private unique(lines: THREE.Vector3[]): THREE.Vector3[] {
        const e = 0.001;
        const isExist = (lines_: THREE.Vector3[], pos1: THREE.Vector3, pos2: THREE.Vector3): boolean => {
            if (pos2.clone().sub(pos1).clone().length() < e) return true;
            const index = lines_.findIndex((val) => val.clone().equals(pos1));
            if (index != -1 && lines_.length > index + 1) return lines_[index + 1].clone().equals(pos2);
            return false;
        }

        // カット
        const deleteIndex = [];
        const createWallList = [];
        const cut = () => {
            lines = lines.map((p: THREE.Vector3) => p.clone());

            for (let j = 0; j < lines.length; j+=2) {
                for (let i = 0; i < lines.length; i++) {
                    if (i == j || i == j + 1) continue;
                    const point = lines[i];
                    const dir1 = point.clone().sub(lines[j]);
                    if (dir1.clone().length() < e && point.clone().sub(lines[j+1]).clone().length() < e) continue;    //3点の距離が短ければ
                    const dir2 = lines[j+1].clone().sub(lines[j]);
                    if (- e < (dir1.clone().dot(dir2) / dir2.length()) && (dir1.clone().dot(dir2) / dir2.length()) < dir2.length() + e) {
                        // y方向の高さがe以内なら
                        const height = dir1.clone().cross(dir2).clone().divideScalar(dir2.length());
                        if (-e < height.length() && height.length() < e) {
                            if (!isExist(lines, lines[j], point) && !isExist(lines, point, lines[j+1])) {
                                deleteIndex.push(...[j, j+1]);
                                createWallList.push(...[lines[j], point, point, lines[j+1]]);
                            }
                        }
                    }
                }
            }
            return;
        }

        cut();        
        if (deleteIndex.length == 0 && createWallList.length == 0) return lines;
        deleteIndex.forEach((i: number) => lines.splice(i, 1));
        createWallList.forEach((p: THREE.Vector3) => lines.push(p));
        console.log(lines);
                        
        // pointListにセットする
        const createWall: THREE.Vector3[] = [];
        for (let i = 0; i < lines.length; i+=2) {
            const isBool = createWall.some((p: THREE.Vector3, index: number, array: THREE.Vector3[]) => {
                if (index % 2 == 1) return;
                return (p.clone().sub(lines[i]).length() < e && array[index + 1].clone().sub(lines[i+1]).length() < e);
            });
            if (!isBool) {
                createWall.push(lines[i].clone());
                createWall.push(lines[i+1].clone());
            }
        }


        return createWall;
    }

    public length(e: number) {
        this.e = e / 1000; /** 単位 mm → m */
    }

}